module.exports = __webpack_public_path__ + "media/assets/icons/choicepoint-img3-a1d0e94b8896f33948e5cee45717c177.svg";